import { ecsClient, POST } from ".";
import { UserProfile } from "@/types";

export type CancelPreviewResponse = {
  eligible: boolean;
  reason?:
    | "not_subscribed"
    | "already_claimed"
    | "not_yearly"
    | "subscription_error";
  interval?: string;
  offer?: {
    type: string;
    percentOff: number;
    appliesAt: string;
    interval: string;
    currentAmount: number;
    discountedAmount: number;
    currentPeriodEnd: string;
  };
};

export type ClaimOfferResponse = {
  success: boolean;
  offerApplied?: string;
  interval?: string;
  currentAmount?: number;
  discountedAmount?: number;
};

const CommonServices = {
  getLinkedEmails: async () => {
    return POST<{ email: string; provider: string }[]>(
      `refundassistant/emails/linked`
    );
  },
  /**
   * Preview cancellation - check if user is eligible for retention offer
   */
  cancelPlanPreview: async () => {
    return POST<CancelPreviewResponse>(`cancel-plan/preview`);
  },
  /**
   * Claim the retention offer (50% off next year for yearly subscriptions)
   */
  claimCancellationOffer: async () => {
    return POST<ClaimOfferResponse>(`claim-cancellation-offer`);
  },
  cancelSubscription: async ({
    reason,
    other,
  }: {
    reason: string;
    other?: string;
  }) => {
    return POST(`cancel-plan`, { reason, other });
  },
  reSubscribe: async () => {
    return POST(`resubscribe`);
  },
  updateUserProfile: async (data: UserProfile) => {
    return POST(`user/update-profile`, data);
  },
  getUserProfile: async () => {
    return POST<UserProfile>(`user/get-profile`);
  },
  setDefaultPaymentMethod: async (data: { setupIntentId: string }) => {
    return POST(`user/set-default-payment-method-from-setup-intent`, data);
  },
  verifyIapReceiptApple: async (data: {
    productId: string;
    transactionId: string;
    isSandbox?: boolean;
    userId?: string;
  }) => {
    return POST(`iap/apple/verify`, data, { timeout: 30000 });
  },
  unsubscribeFromEmail: async (data: {
    newClassActionsUnsubscribed: boolean;
    expiringClassActionsUnsubscribed: boolean;
    monthlyClassActionReportsUnsubscribed: boolean;
    monthlySpendReportsUnsubscribed: boolean;
    weeklySpendReportsUnsubscribed: boolean;
    newSubscriptionsFoundUnsubscribed: boolean;
  }) => {
    return POST(`user/update-email-preferences`, data);
  },
  submitSupportRequest: async (data: { topic: string; message: string }) => {
    const response = await ecsClient.post<{ success: boolean }>(
      `feedback/support`,
      data
    );
    return response.data;
  },
};

export default CommonServices;
